<template>
  <div>
    <fai v-if="canClose" :icon="['fas', 'times']" class="closeMenuButton fa-2x" transform="grow-2" @click="close()" />

    <div class="datos-cliente">
      <fai icon="user-circle" class="fa-2x align-middle" />
      {{ nombreCliente }}
    </div>

    <EnlaceMenuSimple :icono="iconoLogout()" titulo="Cerrar sesión" @click="cerrarSesion()" />

    <EnlaceMenuSimple :icono="iconoMisDatos()" titulo="Mis datos" @click="gotoCliente()" />

    <EnlaceMenuSimple v-if="hayTarjetasMiOficina" :icono="iconoMiOficina()" titulo="Mi oficina"
      @click="gotoMiOficina()" />

    <EnlaceMenuSimple v-if="hayTarjetasServicios" :icono="iconoServicios()" titulo="Servicios"
      @click="gotoServicios()" />

    <EnlaceMenuSimple v-if="hayTarjetasOfertas" :icono="iconoOfertas()" titulo="Ofertas" @click="gotoOfertas()" />

    <EnlaceMenuSimple v-if="hayTarjetasSorteos" :icono="iconoSorteos()" titulo="Sorteos" @click="gotoSorteos()" />

    <EnlaceMenuSimple v-if="hayTarjetasBeneficios" :icono="iconoBeneficios()" titulo="Beneficios"
      @click="gotoBeneficios()" />

    <EnlaceMenuSimple v-if="hayTarjetasInfo" :icono="iconoInformacion()" titulo="Información"
      @click="gotoInformacion()" />  

    <section v-if="hayRecibosPendientes">
      <h1 class="tituloSeccion">Recibos impagados:</h1>

      <EnlaceMenu v-for="item in portfolio.lstAllRecibosPtes" :key="item.idRecibo" :icono="iconoRecibo(item)"
        :titulo="item.titulo" :subtitulo="item.idRecibo" @click="gotoRecibo(item.idRecibo)" />
    </section>

    <section v-if="haySiniestros">
      <h1 class="tituloSeccion">Siniestros abiertos:</h1>

      <EnlaceMenu v-for="item in portfolio.lstSiniestrosVeh" :key="item.numSiniestro" :icono="iconoSiniestroVeh(item)"
        :titulo="item.lugarAccidente" :subtitulo="item.matriculaVA" clase="sini"
        @click="gotoSiniestroVeh(item.numSiniestro)" />

      <EnlaceMenu v-for="item in portfolio.lstSiniestrosHog" :key="item.numSiniestro" :icono="iconoSiniestroHog(item)"
        :titulo="item.direccion" :subtitulo="item.codPostal + ' ' + item.provincia" clase="sini"
        @click="gotoSiniestroHog(item.numSiniestro)" />

      <EnlaceMenu v-for="item in portfolio.lstSiniestrosMov" :key="item.numSiniestro" :icono="iconoSiniestroMov(item)"
        :titulo="item.titulo" :subtitulo="item.subtitulo" clase="sini" @click="gotoSiniestroMov(item.numSiniestro)" />

      <EnlaceMenu v-for="item in portfolio.lstSiniestrosNeg" :key="item.numSiniestro" :icono="iconoSiniestroNeg(item)"
        :titulo="item.riesgo" :subtitulo="item.fecOcurrencia | dateDDMMYYYY" clase="sini"
        @click="gotoSiniestroNeg(item.numSiniestro)" />

      <EnlaceMenu v-for="item in portfolio.lstSiniestrosAcc" :key="item.numSiniestro" :icono="iconoSiniestroAcc(item)"
        :titulo="item.riesgo" :subtitulo="item.fecOcurrencia | dateDDMMYYYY" clase="sini"
        @click="gotoSiniestroAcc(item.numSiniestro)" />

      <EnlaceMenu v-for="item in portfolio.lstSiniestrosMasc" :key="item.numSiniestro" :icono="iconoSiniestroMasc(item)"
        :titulo="item.especie + ' ' + item.nombre" :subtitulo="item.fecOcurrencia | dateDDMMYYYY" clase="sini"
        @click="gotoSiniestroMasc(item.numSiniestro)" />

    </section>

    <section v-if="hayPolizas">
      <h1 class="tituloSeccion">Pólizas:</h1>

      <EnlaceMenu v-for="item in portfolio.lstPolizasVeh" :key="item.idPoliza" :icono="iconoVeh(item)"
        :titulo="item.marca + ' ' + item.modelo" :subtitulo="item.matricula" :subindice="txtRenovacion(item)"
        @click="gotoPolizaVeh(item.idPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasHogar" :key="item.idPoliza" :icono="iconoHogar(item)"
        :titulo="item.direccionCorta" :subtitulo="item.codPostal + ' ' + item.provincia"
        :subindice="txtRenovacion(item)" @click="gotoPolizaHogar(item.idPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasDec" :key="item.idPoliza" :icono="iconoDec(item)"
        :titulo="'Decesos'" :subtitulo="item.producto" :subindice="txtRenovacion(item)"
        @click="gotoPolizaDec(item.idPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasSaludHNA" :key="item.numPoliza" :icono="iconoSalud(item)"
        :titulo="'Salud'" :subtitulo="item.producto" :subindice="txtRenovacion(item)"
        @click="gotoPolizaSalud(item.numPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasMovilidad" :key="item.numPoliza" :icono="iconoMovilidad(item)"
        :titulo="'Movilidad'" :subtitulo="item.riesgoAseguradoStr" :subindice="txtRenovacion(item)"
        @click="gotoPolizaMovilidad(item.idPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasNegocio" :key="item.numPoliza" :icono="iconoNegocio(item)"
        :titulo="'Negocio'" :subtitulo="item.riesgoAseguradoStr" :subindice="txtRenovacion(item)"
        @click="gotoPolizaNegocio(item.idPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasAccidentes" :key="item.numPoliza" :icono="iconoAccidentes(item)"
        :titulo="'Accidentes'" :subtitulo="item.riesgoAseguradoStr" :subindice="txtRenovacion(item)"
        @click="gotoPolizaAccidentes(item.idPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasMascotas" :key="item.numPoliza" :icono="iconoMascotas(item)"
        :titulo="item.especie" :subtitulo="item.nombre" :subindice="txtRenovacion(item)"
        @click="gotoPolizaMascotas(item.idPoliza)" />

      <EnlaceMenu v-for="item in portfolio.lstPolizasSaludMMT" :key="item.numPoliza" :icono="iconoSalud(item)"
        :titulo="item.producto" :subtitulo="item.riesgoAseguradoStr" :subindice="txtRenovacion(item)"
        @click="gotoPolizaSaludMMT(item.idPoliza)" />
    </section>

    <div style="height: 4rem" />
  </div>
</template>

<script>
import IconoMoto from "@/assets/icono_moto.png";
import IconoVeh from "@/assets/icono_auto.png";
import IconoHogar from "@/assets/icono_hogar.png";
import IconoDec from "@/assets/icono_decesos.png";
import IconoSalud from "@/assets/icono_salud.png";
import IconoMovilidad from "@/assets/icono_movilidad.png";
import IconoNegocio from "@/assets/icono_negocio.png";
import IconoAccidentes from "@/assets/icono_accidentes.png";
import IconoRecibo from "@/assets/recibo.png";
import IconoPerfil from "@/assets/picto-comment4x.png";
import IconoServicios from "@/assets/icono_servicios.png";
import IconoOfertas from "@/assets/icono_ofertas.png";
import IconoMiOficina from "@/assets/icono_mi_oficina.png";
import IconoLogout from "@/assets/icono_logout.png";
import IconoBeneficios from "@/assets/icono_beneficios.png";
import IconoInformacion from "@/assets/icono_informacion.png";
import IconoMisDatos from "@/assets/icono_perfil.png";
import IconoSorteos from "@/assets/icono_sorteos.png";
import IconoMascotas from "@/assets/icono_mascotas.png";
import { resetMenuAbierto } from "@/components/Cabecera.vue";

export default {
  props: {
    canClose: { type: Boolean, required: false, default: true },
  },

  computed: {
    portfolio() {
      return this.$store.state.portfolio;
    },
    nombreCliente() {
      return this.portfolio.nsg("cliente.nombre");
    },
    hayPolizas() {
      return (
        this.portfolio.nsg("lstPolizasVeh.length") > 0 ||
        this.portfolio.nsg("lstPolizasHogar.length") > 0 ||
        this.portfolio.nsg("lstPolizasDec.length") > 0 ||
        this.portfolio.nsg("lstPolizasSaludHNA.length") > 0 ||
        this.portfolio.nsg("lstPolizasMovilidad.length") > 0 ||
        this.portfolio.nsg("lstPolizasNegocio.length") > 0 ||
        this.portfolio.nsg("lstPolizasAccidentes.length") > 0 ||
        this.portfolio.nsg("lstPolizasMascotas.length") > 0 ||
        this.portfolio.nsg("lstPolizasSaludMMT.length") > 0
      );
    },
    haySiniestros() {
      return (
        this.portfolio.nsg("lstSiniestrosVeh.length") > 0 ||
        this.portfolio.nsg("lstSiniestrosHog.length") > 0 ||
        this.portfolio.nsg("lstSiniestrosMov.length") > 0 ||
        this.portfolio.nsg("lstSiniestrosNeg.length") > 0 ||
        this.portfolio.nsg("lstSiniestrosAcc.length") > 0 ||
        this.portfolio.nsg("lstSiniestrosMasc.length") > 0
      );
    },
    hayRecibosPendientes() {
      return this.portfolio.nsg("lstAllRecibosPtes.length") > 0;
    },

    hayTarjetasSorteos() {
      //Condiciones de las tarjetas disponible de momento: Freidora Aire Fin Promocion
      const visibleFinSorteoFreidoraAire =
        this.$store.state.portfolio.visibleFinSorteoFreidoraAire;
      return visibleFinSorteoFreidoraAire;
    },

    hayTarjetasMiOficina() {
      const visibleTarjetaMiOficina = this.$store.state.portfolio.cliente.purezaPuroMMT;
      return visibleTarjetaMiOficina;
    },

    hayTarjetasInfo(){
      const visibleTarjetaNuevoReglamentoCirculacion = true;
      return visibleTarjetaNuevoReglamentoCirculacion;
    },

    hayTarjetasServicios() {
      const visibleAsistenciaAuto = this.$store.state.portfolio.tienePolizaConAv == "S";
      const visibleAsistenciaHogar = this.$store.state.portfolio.tienePolizaConAsistenciaHogar == "S";
      const visibleTallerCRM = this.$store.state.portfolio.tienePolizaAutos == "S"
        && this.$store.state.portfolio.cliente.purezaPuroMMT
        && this.$store.state.portfolio.cliente.codPostal.substring(0, 2) == "28";
      const visibleTalleresCalidadPremium = this.$store.state.portfolio.tienePolizaAutos == "S";
      const visibleAJT = this.$store.state.portfolio.tienePolizaConAjt == "S";
      const visibleDeclararSiniestro = this.$store.state.portfolio.tienePolizaMoto == "S"
        || this.$store.state.portfolio.tienePolizaAutos == "S"
      const visibleServiciosDecesosPremium = this.$store.state.portfolio.tienePolizaDecesosPremium;
      const visibleSubsidioParalizacion = this.$store.state.portfolio.cuantasPolizasConSubsidio > 0;
      const visibleCarglass = this.$store.state.portfolio.tienePolizaConLunas == "S";
      return  visibleAsistenciaAuto ||
        visibleAsistenciaHogar ||
        visibleTallerCRM ||
        visibleTalleresCalidadPremium ||
        visibleAJT ||
        visibleDeclararSiniestro ||
        visibleServiciosDecesosPremium ||
        visibleSubsidioParalizacion ||
        visibleCarglass;
    },




    hayTarjetasOfertas() {
      //Condiciones de las tarjetas disponible de momento: TraeUnAmigo, Hogar90, SeguroAuto,SeguroMoto,SeguroHogar, SeguroDecesos, SeguroSaludo1MesGratis,SeguroAccidentes, SeguroNegocios, SeguroMovilidadPersonal, SeguroMascotas, FreidoraAire
      const esPuroMMT = this.$store.state.portfolio.cliente.purezaPuroMMT;

      const visibleTraeUnAmigo =
        this.$store.state.portfolio.nsg("lstCodigosAmigo.length") > 0;
      const visibleHogar90 =
        this.$store.state.portfolio.visiblePromocionHogar90;
      const visibleSeguroAuto =
        esPuroMMT && this.$store.state.portfolio.tienePolizaAuto == "N";
      const visibleSeguroHogar =
        esPuroMMT && this.$store.state.portfolio.tienePolizaHogar == "N";
      const visibleSeguroMoto =
        esPuroMMT && this.$store.state.portfolio.tienePolizaMoto == "N";
      const visibleAccidentes =
        esPuroMMT && this.$store.state.portfolio.tienePolizaAccidentes == "N";
      const visibleNegocios =
        esPuroMMT && this.$store.state.portfolio.tienePolizaNegocios == "N";
      const visibleMovilidadPersonal =
        esPuroMMT && this.$store.state.portfolio.tienePolizaMovilidad == "N";
      const visibleMovilidad =
        esPuroMMT && this.$store.state.portfolio.tienePolizaMovilidad == "N";
      const visibleMascotas = esPuroMMT && this.$store.state.portfolio.tienePolizaMascotas == "N";
      const visiblePromocionSalud1MesGratis = this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaSaludHNA == "N" &&
        this.$store.state.portfolio.tienePolizaSaludMMT == "N" && 
        this.$store.state.portfolio.cliente.edad != null && 
        this.$store.state.portfolio.cliente.edad < 65;
      const visiblePromocionFreidoraAire =
        esPuroMMT && this.$store.state.portfolio.visiblePromocionFreidoraAire;
      
      return (
        visiblePromocionSalud1MesGratis ||
        visibleTraeUnAmigo ||
        visibleHogar90 ||
        visibleSeguroAuto ||
        visibleSeguroHogar ||
        visibleSeguroMoto ||
        visibleAccidentes ||
        visibleMascotas ||
        visibleNegocios ||
        visibleMovilidad ||
        visibleMovilidadPersonal ||
        visiblePromocionFreidoraAire 
      );
    },

    hayTarjetasBeneficios() {
      const visibleTalleresCalidadPremium = this.$store.state.portfolio.cliente.purezaPuroMMT && this.$store.state.portfolio.tienePolizaAutos == "S";
      const visibleTallerCRM = this.$store.state.portfolio.cliente.purezaPuroMMT && this.$store.state.portfolio.tienePolizaAutos == "S" && this.$store.state.portfolio.cliente.codPostal && this.$store.state.portfolio.cliente.codPostal.startsWith("28");
      const visibleClubBeneficios = this.$store.state.portfolio.tienePolizasVigorMMT;
      const visibleTraeUnAmigo = this.$store.state.portfolio.nsg("lstCodigosAmigo.length") > 0;
      const visibleCesur = this.$store.state.portfolio.cliente.purezaPuroMMT;
      return visibleTalleresCalidadPremium || visibleTallerCRM || visibleClubBeneficios || visibleTraeUnAmigo || visibleCesur;
    },
  },

  methods: {
    iconoLogout() {
      return IconoLogout;
    },
    iconoPerfil() {
      return IconoPerfil;
    },
    iconoVeh(item) {
      return item.tipoAutomovil == "MOTO" ? IconoMoto : IconoVeh;
    },

    txtRenovacion(item) {
      if (item.tenemosAvisoCobro) {
        return "Renovación";
      } else return "";
    },

    iconoHogar() {
      return IconoHogar;
    },
    iconoDec() {
      return IconoDec;
    },
    iconoSalud() {
      return IconoSalud;
    },
    iconoMovilidad() {
      return IconoMovilidad;
    },
    iconoNegocio() {
      return IconoNegocio;
    },
    iconoAccidentes() {
      return IconoAccidentes;
    },
    iconoMascotas() {
      return IconoMascotas;
    },
    iconoSiniestroVeh() {
      return IconoVeh;
    },
    iconoSiniestroHog() {
      return IconoHogar;
    },
    iconoSiniestroMov() {
      return IconoMovilidad;
    },
    iconoSiniestroNeg() {
      return IconoNegocio;
    },
    iconoSiniestroAcc() {
      return IconoAccidentes;
    },
    iconoSiniestroMasc() {
      return IconoMascotas;
    },
    iconoRecibo() {
      return IconoRecibo;
    },
    iconoBeneficios() {
      return IconoBeneficios;
    },
    iconoInformacion(){
      return IconoInformacion;
    },
    iconoOfertas() {
      return IconoOfertas;
    },
    iconoMiOficina() {
      return IconoMiOficina;
    },
    iconoMisDatos() {
      return IconoMisDatos;
    },
    iconoServicios() {
      return IconoServicios;
    },
    iconoSorteos() {
      return IconoSorteos;
    },
    gotoPolizaVeh: async function (idPoliza) {
      this.$router.push({
        name: "polizaAutos",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaHogar(idPoliza) {
      this.$router.push({
        name: "polizaHogar",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaDec(idPoliza) {
      this.$router.push({
        name: "polizaDecesos",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaMovilidad(idPoliza) {
      this.$router.push({
        name: "polizaMovilidad",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaNegocio(idPoliza) {
      this.$router.push({
        name: "polizaNegocio",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaAccidentes(idPoliza) {
      this.$router.push({
        name: "polizaAccidentes",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaMascotas(idPoliza) {
      this.$router.push({
        name: "polizaMascotas",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaSaludMMT(idPoliza) {
      this.$router.push({
        name: "polizaSaludMMT",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    gotoPolizaSalud(numPoliza) {
      this.$router.push({
        name: "polizaSalud",
        params: { numPoliza: numPoliza },
      });
      this.$emit("elegido");
    },
    gotoSiniestroVeh(numSiniestro) {
      this.$router.push({
        name: "siniestroAutos",
        params: { numSiniestro: numSiniestro },
      });
      this.$emit("elegido");
    },
    gotoSiniestroHog(numSiniestro) {
      this.$router.push({
        name: "siniestroHogar",
        params: { numSiniestro: numSiniestro },
      });
      this.$emit("elegido");
    },
    gotoSiniestroMov(numSiniestro) {
      this.$router.push({
        name: "siniestroMovilidad",
        params: { numSiniestro: numSiniestro },
      });
      this.$emit("elegido");
    },
    gotoSiniestroAcc(numSiniestro) {
      this.$router.push({
        name: "siniestroAccidentes",
        params: { numSiniestro: numSiniestro },
      });
      this.$emit("elegido");
    },
    gotoSiniestroMasc(numSiniestro) {
      this.$router.push({
        name: "siniestroMascotas",
        params: { numSiniestro: numSiniestro },
      });
      this.$emit("elegido");
    },
    gotoSiniestroNeg(numSiniestro) {
      this.$router.push({
        name: "siniestroNegocio",
        params: { numSiniestro: numSiniestro },
      });
      this.$emit("elegido");
    },
    gotoRecibo(idRecibo) {
      this.$router.push({
        name: "recibo",
        params: { idRecibo: idRecibo },
      });
      this.$emit("elegido");
    },
    gotoCliente() {
      this.$router.push({
        name: "cliente",
      });
      this.$emit("elegido");
    },
    gotoServicios() {
      this.$router.push({
        name: "servicios",
      });
      this.$emit("elegido");
    },
    gotoOfertas() {
      this.$router.push({
        name: "ofertas",
      });
      this.$emit("elegido");
    },
    gotoMiOficina() {
      this.$router.push({
        name: "mioficina",
      });
      this.$emit("elegido");
    },
    gotoSorteos() {
      this.$router.push({
        name: "sorteos",
      });
      this.$emit("elegido");
    },
    gotoBeneficios() {
      this.$router.push({
        name: "beneficios",
      });
      this.$emit("elegido");
    },
    gotoInformacion() {
      this.$router.push({
        name: "informacion",
      });
      this.$emit("elegido");
    },
    gotoAvisoRenovacion(idPoliza) {
      this.$router.push({
        name: "avisoRenovacion",
        params: { idPoliza: idPoliza },
      });
      this.$emit("elegido");
    },
    close() {
      this.$emit("elegido");
    },
    cerrarSesion() {
      resetMenuAbierto();
      this.$store.dispatch("insertAudit", {
        idCliente: this.portfolio.cliente.idCliente,
        nif: this.portfolio.cliente.numDoc,
        nameEvento: "USUARIO_LOGOUT",
        info: this.portfolio.cliente.idCliente,
      });
      this.$store.dispatch("logout");
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../Menus/menus.scss";

.datos-cliente {
  color: lighten($naranjaMMT, 20);
  display: flex;
  align-items: center;
  margin-left: 0.3rem;
  margin-bottom: 1.5rem;

  :first-child {
    margin-right: 1rem;
  }
}

.closeMenuButton {
  float: right;
  color: white;
  z-index: 9999;
}
</style>